<template>
  <div class="footer" :class="[isParty ? 'partyFooter' : '' ,device == 'mobile' ? 'footer-mobile' : '']">
    <div class="containers">
      <div class="link" >
        <div class="linklabel">
          {{ $t('FriendlyLink') }}
        </div>
        <div class="linklist"  v-if="isLinkShow">
          <v-select class="linkitem" v-model="linksUrl[`index`+index]" @change="handleLinkChange($event,index)" :ref="`linkitem-${index}`"  v-for="(item, index) in links" :key="index"
            item-text="title" item-value="url" :items="item.list" :label="item.label" dense outlined></v-select>
          <!-- <v-select class="linkitem" :items="items" label="Outlined style" dense outlined></v-select>
          <v-select class="linkitem" :items="items" label="Outlined style" dense outlined></v-select> -->
        </div>
      </div>
      <div class="top">
        <div class="leftinfo">
          <img class="leftlogo" src="../assets/img/logo@2x.png" />

          <div class="service" :class="[`service-`+$i18n.locale]">
            {{ $t('BeforeService') }}
          </div>
          <div class="servicePhone" v-if="systemInfo && systemInfo.phone">
            <img class="servicePhone-phone" src="../assets/img/footerphone@2x.png" />
            <span class="servicePhone-span" :class="[`servicePhone-span-`+$i18n.locale]">{{ systemInfo.phone ? systemInfo.phone : '' }}</span>
          </div>
          <div class="servicePhone serviceMail" v-if="systemInfo && systemInfo.email" @click="sendEmail(systemInfo.email)">
            <img class="servicePhone-email" src="../assets/img/footeremail@2x.png" />
            <span class="servicePhone-span" :class="[`servicePhone-span-`+$i18n.locale]">{{ systemInfo.email ? systemInfo.email : '' }}</span>
          </div>
          <div class="mt">
            <div class="mtitem" :class="[`mtitem-`+$i18n.locale]" v-if="systemInfo && systemInfo.extend1">
              <div class="name">
                {{$t('OfficialAccounts')}}
              </div>
              <img class="mtico" :src="systemInfo.extend1" />
            </div>
            <div class="mtitem" :class="[`mtitem-`+$i18n.locale]" v-if="systemInfo && systemInfo.extend2">
              <div class="name">
                {{$t('Douyin')}}
              </div>
              <img class="mtico" :src="systemInfo.extend2" />
            </div>
          </div>
        </div>
        <div class="rightinfo">
          <div class="categoryitem" :class="[`categoryitem-`+$i18n.locale]" v-for="(item, index ) in category" :key="index">
            <div class="name" :class="[`name-`+$i18n.locale]">
              {{ item.columnName }}
            </div>
            <div class="list">
              <div class="listitem line-1"  :class="[`listitem-`+$i18n.locale]" @click="menuClick(sitem, item)" v-for="(sitem, sindex) in item.menu" :key="sindex">
                {{ sitem.columnName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
       {{$t('AllRightsReserved')}} © {{$t('CompanyName')}} 鄂ICP备08002516号-1 鄂高工商网备字013号
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'
export default {
  data() {
    return {
      links: [],
      systemInfo: {
        phone: '',//售前服务电话
        extend1: '',//公众号
        extend2: '',//抖音视频号
      },
      isLinkShow:true,
      linksUrl:{
        index0:'',
            index1:'',
            index2:'',
            index3:'',
            index4:''
      },
      isParty: false,
      category: []
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    }),
  },
  watch: {
    '$route': {
      handler(to) {
        this.$nextTick(() => {
          this.initLinks()
          if (to.path.indexOf('/party/building') > -1) {
            this.isParty = true
          } else {
            this.isParty = false
          }

        })

      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    }
  },
  mounted(){
    this.initLinks()
    this.initCategory()
    this.initSystem()

    this.$Bus.$off('updateLinks')
    this.$Bus.$on('updateLinks',() => {
      this.initLinks()
    })
    this.$Bus.$off('updateFooterData')
    this.$Bus.$on('updateFooterData',() => {
      this.initCategory()
    })
    this.$Bus.$off('updateSystem')
    this.$Bus.$on('updateSystem',() => {
      this.initSystem()
    })

  },
  methods: {
    initLinks(){
      this.links = JSON.parse(localStorage.getItem('linksObj'))
    },
    initSystem(){
      this.systemInfo = JSON.parse(localStorage.getItem('systemObj'))
    },
    initCategory(){
          var category = JSON.parse(localStorage.getItem('footerLists'))
          if(category){
            if(this.$i18n.locale == 'en'){
              category = category.filter((item) => item.code != 'CONSTRUCT')
            }
            this.category = category
         }
    },
    handleLinkChange(e,index) {
      var url = this.linksUrl[`index${index}`] 
      if(url.length > 2){
        window.open(url, '_blank')
        setTimeout(() => {
          this.linksUrl ={
            index0:'',
            index1:'',
            index2:'',
            index3:'',
            index4:''
          }
          this.isLinkShow = false
        },1)
        setTimeout(() => {
          
          this.isLinkShow = true
        },10)

        this.$forceUpdate()
      }
    },
    menuClick(item, pitem) {
      console.log(item, 'item==')
      if (pitem.code == 'SERVICE') {
        this.isMenuShow = false
        this.$router.push({
          path: '/service/list?id=' + item.id
        })
      } else {
        if(item.code.indexOf('INFOS') > -1){
          this.$router.push({
              path: item.url
          })
        }else{
          if (item.url) {
            this.$router.push({
              path: item.url
            })
          }
        }
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.footer {
  // position:fixed;
  // left:0;
  // bottom: 0;
  width: 100%;
  height: 606px;
  background: #164690;
  transition: all 0.3s;

  .containers {
    .link {
      width: 100%;
      height: 83px;
      border-bottom: 1px solid #3F5F84;
      display: flex;
      flex-direction: row;
      align-items: center;

      .linklabel {
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 32px;
      }

      .linklist {
        padding-left: 140px;
        box-sizing: border-box;
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .linkitem {
        width: 228px;
        height: 45px;
        // background: #3C6BB5;
        border-radius: 0px 0px 0px 0px;

        // border: 1px solid #6E9BE1;
        //清除select的边框样式


      }
    }

    .top {
      width: 100%;
      height: 433px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .leftinfo {
        width: 20%;

        .leftlogo {
          width: 131px;
          height: 131px;
          margin-bottom: 10px;
        }

        .service {
          font-weight: 500;
          font-size: 20px;
          color: #8FA8CE;
          margin-bottom: 15px;
        }
        .service-en{
          font-weight: 400;
          font-size: 16px;
        }

        .servicePhone {
          height: 28px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .servicePhone-phone {
            width: 16px;
            height: 16px;
            margin-right: 13px;
          }

          .servicePhone-email {
            width: 16px;
            height: 13px;
            margin-right: 13px;
          }

          .servicePhone-span {
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            text-align: left;
          }
          .servicePhone-span-en {
            font-weight: 300;
            font-size: 16px;
            color: #FFFFFF;
            text-align: left;
          }
        }
        .serviceMail{
          cursor: pointer;
        }

        .mt {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 30px;

          .mtitem {
            margin-right: 45px;

            .name {
              font-weight: 500;
              font-size: 20px;
              color: #8FA8CE;
              margin-bottom: 10px;
              white-space: nowrap;
            }


            .mtico {
              width: 83px;
              height: 83px;
            }
          }
          .mtitem-en{
            .name {
              font-weight: 400;
              font-size: 18px;
              color: #8FA8CE;
              margin-bottom: 10px;
              white-space: nowrap;
            }
          }
        }
      }

      .rightinfo {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        padding-top: 40px;
        box-sizing: border-box;
        width: 80%;

        .categoryitem {
          width: 20%;

          .name {
            font-weight: 500;
            font-size: 20px;
            color: #FFFFFF;
            white-space: nowrap;
          }
          .name-en{
            font-size: 18px;
            font-weight: 400;
          }

          .list {
            padding-top: 26px;
            box-sizing: border-box;

            .listitem {
              font-weight: 500;
              font-size: 18px;
              color: #8FA8CE;
              line-height: 36px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              cursor: pointer;
              padding-right: 15px;
              box-sizing: border-box;
            }

            .listitem-en{
              font-weight: 300;
              font-size: 15px;
              line-height: 20px;
              -webkit-line-clamp:unset!important;
              white-space:unset!important;
              margin-bottom: 10px;
            }
          }
        }

      }
    }

    .bottom {
      height: 90px;
      line-height: 90px;
      text-align: center;
      border-top: 1px solid #3F5F84;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
    }
  }
}

.partyFooter {
  background: #B51408;
  transition: all 0.3s;

  .containers {
    .top {
      .leftinfo {
        .service {
          color: #FF978F;
        }

        .mt {
          .mtitem {
            .name {
              color: #FF978F;
            }
          }
        }
      }

      .rightinfo {
        .categoryitem {
          .list {
            .listitem {
              color: #FF978F;
            }
          }
        }
      }
    }

    .bottom {
      border-top: 1px solid #DB483D;
    }
  }
}

</style>
<style lang="scss">
.footer {
  .link {
    .v-text-field--outlined fieldset {
      background: #3C6BB5;

      border: 1px solid #6E9BE1 !important;
    }

    .v-input {
      flex: unset !important;
    }

    .v-icon {
      color: white !important;
    }

    .v-label {
      color: white !important;
      font-size: 16px!important;
    }

    .v-select__selection {
      color: white !important;

    }
  }
}

.partyFooter {

  .link {
    border-bottom: 1px solid #DB483D !important;

    .v-text-field--outlined fieldset {
      background: #D41F12;

      border: 1px solid #EC4336 !important;
    }

    .v-input {
      flex: unset !important;
    }

    .v-icon {
      color: white !important;
    }

    .v-label {
      color: white !important;
    }

    .v-select__selection {
      color: white !important;

    }
  }
}
.footer-mobile{
  .v-input .v-label{
    height: 12px;
    line-height:12px;
  }
  .v-select__slot{
    height: 45px;
  }
  .v-input__icon{
    height: 24px;
    width: 24px;
  }
  .v-icon.v-icon{
    font-size: 24px;
  }
  .v-text-field--outlined.v-input--dense .v-label{
    top:10px;
  }
}
</style>